export const filterNatFileErrors = (natFileErrors, selectedAntaId) => {
    const filteredErrors = natFileErrors.filter(natError => natError.AntaId === selectedAntaId)

    return filteredErrors
}